"use strict";

(() => {
    let viewportHeight = window.innerHeight;
    const activeParallaxElements = new Set();
    const activeLines = new Set();
    let ticking = false;

    const updateViewport = () => viewportHeight = window.innerHeight;
    window.addEventListener("resize", updateViewport);
    window.addEventListener("orientationchange", updateViewport);

    // Parallax effect system

    const parallaxData = (element) => {
        if (element._parallaxData)
            return;

        const rect = element.getBoundingClientRect();
        const [start, end] = element.dataset.parallax.split(",").map(v => (Number(v) / 1000) * viewportHeight);

        element._parallaxData = {
            start,
            end,
            type: element.dataset.parallaxType || "vertical",
            elementTop: rect.top + window.scrollY,
            unitScroll: (end - start) / (viewportHeight + rect.height)
        };
    };

    const parallaxObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const element = entry.target;

            if (entry.isIntersecting) {
                parallaxData(element);
                activeParallaxElements.add(element);
            } else {
                activeParallaxElements.delete(element);
                delete element._parallaxData;
            }
        });
    }, { threshold: 0 });

    const parallaxRO = new ResizeObserver((entries) => {
        entries.forEach(entry => parallaxData(entry.target));
    });

    document.querySelectorAll("[data-parallax]").forEach(el => {
        parallaxObserver.observe(el);
        parallaxRO.observe(el);
    });

    const handleScroll = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                activeParallaxElements.forEach(element => {
                    const data = element._parallaxData;
                    const relativeDistance = window.scrollY + viewportHeight - data.elementTop;
                    const value = data.unitScroll * relativeDistance + data.start;
                    switch (data.type) {
                        case "horizontal":
                            element.style.transform = `translate3d(${value}px, 0, 0)`;
                            break;
                        case "rotate":
                            element.style.transform = `rotate(${value}deg)`;
                            break;
                        case "scale":
                            element.style.transform = `scale(${1 + value / 100})`;
                            break;
                        case "opacity":
                            element.style.opacity = 1 + value / 100;
                            break;
                        default:
                            element.style.transform = `translate3d(0, ${value}px, 0)`;
                            break;
                    }
                });

                activeLines.forEach(line => {
                    const data = line._parallaxData;
                    const progress = Math.min(Math.max(window.scrollY - data.startScroll, 0) / data.maxHeight, 1);
                    line.style.transform = `scaleY(${progress})`;
                });

                ticking = false;
            });

            ticking = true;
        }
    };

    window.addEventListener('scroll', handleScroll);
    requestAnimationFrame(() => handleScroll());
})();